import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Tag } from '../models/tag';
import { Paginator } from '../models/paginator';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor(
    private http: HttpClient
  ) {
  }

  create(tag: Tag) {
    return firstValueFrom(this.http
      .post<Tag>(`${environment.backend}/tags`, tag));
  }


  exists(label: string) {
    return firstValueFrom(this.http
      .get<{ exists: boolean }>(`${environment.backend}/tags/exists/${label}`));
  }

  documentsCount(id: string) {
    return firstValueFrom(this.http
      .get<{ count: number }>(`${environment.backend}/tags/${id}/documents/count`));
  }


  retrieveAll(pageNumber: number, limit: number, offset: number, query?: string): Promise<Paginator<Tag>> {
    let params = new HttpParams()
      .set('page', pageNumber)
      .set('limit', limit)
      .set('offset', offset)


    if (query) {
      params = params.set('q', query);
    }

    return firstValueFrom(this.http
      .get<Paginator<Tag>>(`${environment.backend}/tags/search`, { params }));
  }

  retrieveByIds(ids: string[]) {
    const params = new HttpParams().appendAll({ ids });
    return firstValueFrom(
      this.http.get<Tag[]>(
        `${environment.backend}/tags`,
        { params },
      ),
    );
  }

  update(id: string, tag: Tag) {
    return firstValueFrom(this.http
      .put<Tag>(`${environment.backend}/tags/${id}`, tag));
  }

  delete(id: string) {
    return firstValueFrom(this.http
      .delete<void>(`${environment.backend}/tags/${id}`));
  }

}
